var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNayatelBlackLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 22,
    viewBox: "0 0 104 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.058 0.0703125H52.1676L45.3281 17.6473H48.7161L53.5563 5.18618L54.1162 5.23861L60.3383 21.9436H64.2312L56.058 0.0703125Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1044 0.0924417L14.0874 15.8587L3.41593 0.0856758L0.00761164 0.0839844L0 17.6719H2.93386L2.92371 5.79948H3.40663L14.112 21.9784L17.5135 21.9776L17.5025 0.0932875L14.1044 0.0924417Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7901 0.0703125L18.9531 17.6473H22.3403L27.1805 5.18618L27.7395 5.23861L33.9667 21.9436H37.8562L29.6847 0.0703125H25.7901Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6953 0.0703125L40.9684 10.0838H40.3587L35.9118 0.0703125H32.5195L39.4131 13.8913V21.9436H42.2506V13.8389L49.0858 0.0703125H45.6953Z",
    fill: "#757575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.6683 0.0693505H76.3302L73.1409 4.84438H70.5098V5.70788H72.5641L65.3753 16.4487C65.2235 16.701 65.0876 16.9626 64.9685 17.2319C62.2317 15.625 55.5208 14.6296 53.4276 14.6101C51.128 14.594 43.6171 15.3527 41.918 17.5541C45.4641 16.5697 49.4873 15.7434 53.2415 15.8432C57.0973 15.9438 61.0824 16.8158 64.7816 17.7131C63.5629 21.1806 66.3784 23.3043 69.6522 21.0453C71.4198 19.748 72.8779 18.2586 75.3305 15.7958C75.3077 18.361 76.424 20.9743 77.7688 21.453C83.3675 23.1318 87.0896 16.7388 90.8938 13.399C89.9996 14.7394 89.2717 16.1835 88.7261 17.6996C87.9007 20.4195 89.4805 23.0159 93.0622 20.9633C95.1766 19.5154 97.1319 17.8645 99.1651 15.7798L99.1702 15.3129C96.9112 17.1812 92.4339 21.5841 90.4362 20.7053C88.3684 19.4469 97.2596 9.82662 103.075 0H100.229C95.6527 7.09574 85.673 18.898 81.0553 20.636C77.5134 21.9748 77.5193 17.3182 78.2796 17.2082C82.4237 16.5206 85.1368 15.0998 87.2047 12.6641C88.4809 9.98308 86.8545 8.47175 83.3143 8.8887C76.0688 10.9777 71.1839 20.3501 67.4897 20.8051C66.2837 20.9328 66.2481 19.4646 67.0448 18.5216L75.8092 5.70788H81.5864V4.84438H76.4012L79.6683 0.0693505ZM78.5612 16.3075C80.492 11.2745 85.213 8.65697 85.7255 10.34C86.4579 12.7732 82.7053 14.9467 78.5612 16.3075Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNayatelBlackLogo);
export default __webpack_public_path__ + "static/media/Nayatel_Black_Logo.9845782e915459667e3531c6c1329bc4.svg";
export { ForwardRef as ReactComponent };